// extracted by mini-css-extract-plugin
export default {"card":"SimilarProductCard_card__DliOM"};